// null number should be treated as infinity
export const getQuantityNumber = (quantity: number | null | undefined) =>
  quantity ?? Number.POSITIVE_INFINITY;
